import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=613f7ac8&scoped=true&"
import script from "./NewsList.vue?vue&type=script&lang=js&"
export * from "./NewsList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/css.css?vue&type=style&index=0&id=613f7ac8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613f7ac8",
  null
  
)

export default component.exports